import React from "react";
import classNames from "classnames";
import type { ICollapsibleProps } from "@similarweb/ui-components";
import { StyledCollapsible } from "./styles";

const Collapsible = (props: ICollapsibleProps & { maxHeight?: number | string }) => {
    const [isExpandFinished, setIsExpandFinished] = React.useState(false);

    const handleTransitionEnd = () => {
        if (props.isActive) {
            setIsExpandFinished(true);
        }
    };

    React.useEffect(() => {
        if (!props.isActive) {
            setIsExpandFinished(false);
        }
    }, [props.isActive]);

    return (
        <StyledCollapsible
            {...props}
            onTransitionEnd={handleTransitionEnd}
            className={classNames(props.className, { expanded: isExpandFinished })}
            maxHeight={props.maxHeight}
        />
    );
};

export default Collapsible;
